import { Controller } from "@hotwired/stimulus"
import { createAlert } from "../scripts/createAlert"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    // Handle form submission events
    this.element.addEventListener('ajax:success', this.handleSuccess.bind(this))
    this.element.addEventListener('ajax:error', this.handleError.bind(this))
  }

  handleSuccess(event) {
    const [data, status, xhr] = event.detail

    if (data.success) {
      createAlert('success', data.message || 'Layout element updated successfully!')
    } else {
      createAlert('danger', data.message || 'Failed to update layout element')
    }
  }

  handleError(event) {
    const [data, status, xhr] = event.detail

    if (data.errors) {
      const errorMessages = Object.values(data.errors).flat().join(', ')
      createAlert('danger', `Error: ${errorMessages}`)
    } else {
      createAlert('danger', data.message || 'An error occurred while updating the layout element.')
    }
  }
}
